import { FilterGroup, Tag } from "@hatch-digital-nl/bravilor-storybook";
import { useGetRefurbishedFiltersQuery } from "../../../common/api/refurbished";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

interface ReturnType {
    filterGroups: FilterGroup[];
    isLoading: boolean;
    isFetching: boolean;
}

export const useFilters = (): ReturnType => {
    const { t } = useStringTranslation();
    const {
        data: filtersData,
        isLoading: filtersDataIsLoading,
        isFetching: filtersDataIsFetching,
    } = useGetRefurbishedFiltersQuery();

    const filterGroups: FilterGroup[] = [
        {
            id: "category_id",
            label: t("category"),
            options:
                filtersData?.data?.categories.map((category) => ({
                    id: category.id.toString(),
                    label: category.label,
                    count: category.product_count,
                })) || [],
        },
        {
            id: "grade_id",
            label: t("grade"),
            options:
                filtersData?.data?.grades.map((grade) => ({
                    id: grade.id.toString(),
                    label: grade.label,
                    content: <Tag variant="grade">{grade.label}</Tag>,
                })) || [],
        },
    ];

    return {
        filterGroups,
        isLoading: filtersDataIsLoading,
        isFetching: filtersDataIsFetching,
    };
};
